var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiledownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 37.5,
    rx: 4.25,
    fill: "#14AE78"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 37.5,
    rx: 4.25,
    stroke: "#14AE78",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8266 10.0499C14.9086 10.3952 11.0263 14.4943 11.0263 19.5C11.0263 24.7322 15.2678 28.9737 20.5 28.9737C25.7322 28.9737 29.9737 24.7322 29.9737 19.5C29.9737 15.029 26.8765 11.2813 22.7105 10.2856V9.23313C27.4481 10.2482 31 14.4592 31 19.5C31 25.299 26.299 30 20.5 30C14.701 30 10 25.299 10 19.5C10 13.701 14.701 9 20.5 9C20.6587 9 20.8167 9.00355 20.9737 9.0105V10.0379L20.9581 10.0371V22.6161L25.3476 18.9092L26.1477 19.7094L20.9494 24.225C20.5172 24.6572 19.9973 24.685 19.8266 24.5143V10.0499ZM19.0267 21.9915V23.4319L14.8158 19.8142L15.5279 18.9347L19.0267 21.9914V21.9915Z",
    fill: "white",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiledownload);
export default __webpack_public_path__ + "static/media/filedownload.dbc2f6c1f6937a62b246cfe179ca1d24.svg";
export { ForwardRef as ReactComponent };